import React from 'react';

import { useSelector } from '@lumapps/redux/react';

import { getWidget } from '../../ducks/selectors';
import type { WidgetState } from '../../ducks/type';

export const EMPTY = {} as Partial<WidgetState>;

export const useWidgetState = (widgetId: string) => {
    const getCurrentWidget = React.useCallback((state: FrontOfficeStore) => getWidget(state, { widgetId }), [widgetId]);
    const widget = useSelector(getCurrentWidget) || EMPTY;
    return widget;
};
